var map = {
	"./burger-menu.svg": 2937,
	"./google.svg": 9745,
	"./sli-accept.svg": 3455,
	"./sli-add-folder.svg": 153,
	"./sli-analytics.svg": 917,
	"./sli-arrow-down.svg": 4575,
	"./sli-arrow-right.svg": 4655,
	"./sli-audio.svg": 3743,
	"./sli-bell.svg": 1772,
	"./sli-browse.svg": 9,
	"./sli-calendar.svg": 4841,
	"./sli-card-search.svg": 5422,
	"./sli-case.svg": 7007,
	"./sli-chat.svg": 5645,
	"./sli-check.svg": 3393,
	"./sli-circle-check.svg": 8320,
	"./sli-clock.svg": 2619,
	"./sli-close-square.svg": 8655,
	"./sli-close.svg": 8026,
	"./sli-close2.svg": 293,
	"./sli-code.svg": 7704,
	"./sli-color-palette.svg": 8446,
	"./sli-copy.svg": 4280,
	"./sli-document.svg": 9944,
	"./sli-dots.svg": 5959,
	"./sli-edit.svg": 1311,
	"./sli-expand.svg": 8831,
	"./sli-file-uploading.svg": 3567,
	"./sli-files.svg": 1100,
	"./sli-headphone.svg": 2263,
	"./sli-help.svg": 7634,
	"./sli-home.svg": 7982,
	"./sli-incognito.svg": 2567,
	"./sli-info.svg": 819,
	"./sli-left.svg": 3100,
	"./sli-light.svg": 1145,
	"./sli-link.svg": 5823,
	"./sli-list.svg": 3751,
	"./sli-logo.svg": 6834,
	"./sli-logout.svg": 8757,
	"./sli-mic.svg": 8428,
	"./sli-minimize.svg": 8211,
	"./sli-moon.svg": 8812,
	"./sli-move.svg": 9136,
	"./sli-new-chat.svg": 2946,
	"./sli-notebook.svg": 7276,
	"./sli-password.svg": 5900,
	"./sli-pause.svg": 4219,
	"./sli-pie-chart-thin.svg": 5708,
	"./sli-pie-chart.svg": 9084,
	"./sli-play.svg": 2645,
	"./sli-plus.svg": 2187,
	"./sli-print.svg": 3468,
	"./sli-refresh.svg": 2576,
	"./sli-reorder.svg": 6508,
	"./sli-resize.svg": 5783,
	"./sli-right.svg": 6131,
	"./sli-robot.svg": 4361,
	"./sli-search.svg": 983,
	"./sli-security.svg": 189,
	"./sli-send.svg": 7457,
	"./sli-settings.svg": 4895,
	"./sli-share-circle.svg": 9553,
	"./sli-share.svg": 4020,
	"./sli-sidebar.svg": 5753,
	"./sli-sound.svg": 7192,
	"./sli-star.svg": 9439,
	"./sli-stop.svg": 9403,
	"./sli-sun.svg": 7487,
	"./sli-switch.svg": 6327,
	"./sli-text.svg": 1742,
	"./sli-trash.svg": 8843,
	"./sli-tuning.svg": 4104,
	"./sli-upload-2.svg": 8917,
	"./sli-upload.svg": 5784,
	"./sli-user.svg": 1498,
	"./sli-user2.svg": 7268,
	"./sli-video.svg": 5776,
	"./sli-wallet.svg": 5824,
	"./sli-widget.svg": 4147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;